import { IonDate } from '../components/IonDate';

const CheckNotNull = Symbol('CheckNotNull');

class Member {
    membership_registrationID: string =  '';
    memberID: string  = '';
    member_typeID: string = '';
    accounts_allotment: number = 0;
    // allotment_left: number = 0; ---remove allotment left, check allotment left by deduct accounts allotment with numbers of memberUsers
    status: number = 0;
    // expiry_date: Date = new Date(); ---deprecated to check membershipContract
    company_name: string = '';
    registered_address: string = '';
    // date_of_incorporation: Date = new Date(); ---deprecated
    // complex_representing: string = ''; ---deprecated
    correspondence_address: string = '';
    complex_representing: string = '';
    telephone_no: string = '';
    // fax: string = ''; --removed
    email: string = '';
    gross_build_up_area: number = 0;
    net_lettable_area: number = 0;
    website: string = '';
    e_invoice_pin: string = '';
    company_number: string = ''; //readonly
    half_year_advance_payment_count: number = 0;
    datetime_updated: Date | null = null;

    constructor(
        membership_registrationID: string,
        memberID: string,
        member_typeID: string,
        accounts_allotment: string,
        // allotment_left: string,
        status: string,
        // expiry_date: string,
        company_name: string,
        registered_address: string,
        // date_of_incorporation: string,
        // complex_representing: string,
        correspondence_address: string,
        complex_representing: string,
        telephone_no: string,
        // fax: string,
        email: string,
        gross_build_up_area: string,
        net_lettable_area: string,
        website: string,
        e_invoice_pin: string,
        company_number: string,
        half_year_advance_payment_count: string,
        datetime_updated: string
    ) {
        this.membership_registrationID = this[CheckNotNull](membership_registrationID) ? membership_registrationID : '';
        this.memberID = this[CheckNotNull](memberID) ? memberID : '';
        this.member_typeID = this[CheckNotNull](member_typeID) ? member_typeID : '';
        this.accounts_allotment = this[CheckNotNull](accounts_allotment) ? parseInt(accounts_allotment): 0;
        // this.allotment_left = this[CheckNotNull](allotment_left) ? parseInt(allotment_left) : 0;
        this.status = this[CheckNotNull](status) ? parseInt(status) : 0;
        // this.expiry_date = this[CheckNotNull](expiry_date) ? IonDate(expiry_date): new Date();
        this.company_name = this[CheckNotNull](company_name) ? company_name : '';
        this.registered_address = this[CheckNotNull](registered_address) ? registered_address : '' ;
        // this.date_of_incorporation = this[CheckNotNull](date_of_incorporation) ? IonDate(date_of_incorporation) : new Date();
        // this.complex_representing = this[CheckNotNull](complex_representing) ? complex_representing : '';
        this.correspondence_address = this[CheckNotNull](correspondence_address) ? correspondence_address : '';
        this.complex_representing = this[CheckNotNull](complex_representing) ? complex_representing : '';
        this.telephone_no = this[CheckNotNull](telephone_no) ? telephone_no : '';
        // this.fax = this[CheckNotNull](fax) ? fax : '';
        this.email = this[CheckNotNull](email) ? email : '';
        this.gross_build_up_area = this[CheckNotNull](gross_build_up_area) ? parseFloat(gross_build_up_area): 0;
        this.net_lettable_area = this[CheckNotNull](net_lettable_area) ? parseFloat(net_lettable_area) : 0;
        this.website = this[CheckNotNull](website) ? website : '';
        this.e_invoice_pin = this[CheckNotNull](e_invoice_pin) ? e_invoice_pin : '';
        this.company_number = this[CheckNotNull](company_number) ? company_number : '';
        this.half_year_advance_payment_count = this[CheckNotNull](half_year_advance_payment_count) ? parseInt(half_year_advance_payment_count) : 0;
        this.datetime_updated = this[CheckNotNull](datetime_updated) ? IonDate(datetime_updated) : null;
    }

    private [CheckNotNull] = (value: string) => {
        if(value && value != null && value != 'null' && value.length > 0)
            return true;
        else
            return false;
    } 
}
export default Member;